import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
} from "chart.js";
import PropTypes from "prop-types";

import "../../dashboard-shared/line-graph.scss";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Legend, Tooltip);

const LineGraph = ({ xlabels, label1, dateForLabel1, label2, dateForLabel2, isMagnified }) => {
  return (
    <div className={`wrapper${isMagnified ? "-magnified" : ""}`}>
      <Line
        data={{
          labels: xlabels,
          datasets: [
            {
              label: label1,
              data: dateForLabel1,
              borderColor: "#F56C6C",
              backgroundColor: "#F56C6C",
              pointBackgroundColor: "white",
              pointHoverBackgroundColor: "#F56C6C",
              tension: 0.2,
            },
            {
              label: label2,
              data: dateForLabel2,
              borderColor: "#BFBFBF",
              backgroundColor: "#BFBFBF",
              pointBackgroundColor: "white",
              pointHoverBackgroundColor: "#BFBFBF",
              tension: 0.2,
            },
          ],
        }}
        options={{
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: isMagnified ? 70 : 50,
              left: isMagnified ? 210 : 10,
              right: isMagnified ? 225 : 48,
            },
          },
          scales: {
            x: {
              ticks: {
                padding: 10,
                color: "#333333",
                font: {
                  weight: 400,
                },
              },
            },
            y: {
              ticks: {
                padding: 20,
                color: "#333333",
                font: {
                  weight: 400,
                },
              },
            },
          },
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                color: "#333333",
                padding: isMagnified ? 50 : 30,
                boxWidth: isMagnified ? 19 : 14,
                boxHeight: isMagnified ? 19 : 14,
                font: {
                  size: isMagnified ? 18 : 14,
                  weight: 500,
                },
              },
            },
            tooltip: {
              enabled: true,
              mode: "nearest",
              intersect: false,
            },
            datalabels: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
};

LineGraph.propTypes = {
  xlabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  label1: PropTypes.string.isRequired,
  dateForLabel1: PropTypes.arrayOf(PropTypes.number),
  label2: PropTypes.string.isRequired,
  dateForLabel2: PropTypes.arrayOf(PropTypes.number),
  isMagnified: PropTypes.bool,
};

LineGraph.defaultProps = {
  dateForLabel1: [],
  dateForLabel2: [],
  isMagnified: false,
};

export default LineGraph;